/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type RatesAndInternalCostLitePage_project = {
    readonly id: string;
    readonly budgetType: BUDGET_TYPE | null;
    readonly flatRate: number | null;
    readonly flatCost: number | null;
    readonly " $refType": "RatesAndInternalCostLitePage_project";
};
export type RatesAndInternalCostLitePage_project$data = RatesAndInternalCostLitePage_project;
export type RatesAndInternalCostLitePage_project$key = {
    readonly " $data"?: RatesAndInternalCostLitePage_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RatesAndInternalCostLitePage_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatesAndInternalCostLitePage_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flatRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flatCost",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = 'aaafbc8bdcd73a1b4d2c4bf6b99fb5b2';
export default node;
